import { render, staticRenderFns } from "./form-item-jushuitan-order-ids.vue?vue&type=template&id=3fb7bdf2&scoped=true"
import script from "./form-item-jushuitan-order-ids.vue?vue&type=script&lang=js"
export * from "./form-item-jushuitan-order-ids.vue?vue&type=script&lang=js"
import style0 from "./form-item-jushuitan-order-ids.vue?vue&type=style&index=0&id=3fb7bdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7bdf2",
  null
  
)

export default component.exports